import { render } from "./KindergartenHeadsView.vue?vue&type=template&id=375f49b8&scoped=true&ts=true"
import script from "./KindergartenHeadsView.vue?vue&type=script&lang=ts"
export * from "./KindergartenHeadsView.vue?vue&type=script&lang=ts"

import "./KindergartenHeadsView.vue?vue&type=style&index=0&id=375f49b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-375f49b8"]])

export default __exports__